import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
//import Main from "../views/main.vue"
import Login from '../views/Login.vue'
import dashboard_org_admin from '../views/dashboard-org_admin.vue'
import create_user from '../views/create-user.vue'
import dashboard_org_professional from '../views/dashboard-org_professional.vue'
import create_document from '../views/create-document.vue'
import dashboard_admin from '../views/dashboard-admin.vue'
import create_org_admin from '../views/create-org-admin.vue'
import verify_fs_set from '../views/verify-fs-set.vue'
import view_fs_set from '../views/view-fs-set.vue'

import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import { logEvent } from '@/firebaseAnalytics';

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true, title: 'Home' }
  },
  {
	path: "/login",
	name: "login",
	component: Login
  },
  {
	path: "/dashboard-org-admin",
	name: "dashboard-org-admin",
	component: dashboard_org_admin,
	meta: { requiresAuth: true, title: 'Org Admin Dashboard' }
  },
  {
	path: "/create-user",
	name: "create-user",
	component: create_user,
	meta: { requiresAuth: true, title: 'Create User' }
  },
  {
	path: "/create-org-admin",
	name: "create-org-admin",
	component: create_org_admin,
	meta: { requiresAuth: true, title: 'Create Org Admin' }
  },
  {
	path: "/dashboard-org-professional",
	name: "dashboard-org-professional",
	component: dashboard_org_professional,
	meta: { requiresAuth: true, title: 'My Dashboard' }
  },
  {
	path: "/create-document",
	name: "create-document",
	component: create_document,
	meta: { requiresAuth: true, title: 'Create Document' }
  },
  {
	path: "/dashboard-admin",
	name: "dashboard-admin",
	component: dashboard_admin,
	meta: { requiresAuth: true, title: 'Admin Dashboard' }
  },
  {
	path: "/verify-fs-set",
	name: "verify-fs-set",
	component: verify_fs_set,
	meta: { requiresAuth: true, title: 'Verify Financial Statement' }
  },
  {
	path: "/view-fs-set/:id",
	name: "view-fs-set",
	component: view_fs_set,
	meta: { requiresAuth: true, title: 'Statement Set' }
  },
  {
	path: '/profile',
	name: 'profile',
	component: () => import('../views/profile.vue'),
	meta: { requiresAuth: true, title: 'My Profile' }
  },
  {
	path: '/scan',
	name: 'scan-qr',
	component: () => import('../views/scan-qr.vue'),
	meta: { requiresAuth: true, title: 'Scan QR Code' }
  },
  {
	path: '/about',
	name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
	component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
	const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
	const isAuthenticated = firebase.auth().currentUser;
	if (requiresAuth && !isAuthenticated) {
		next("/login");
	} else {
		next();
	}
})

router.afterEach((to) => {
	logEvent('page_view', {
		page_title: to.meta.title || to.name,
		page_path: to.path
	});
})

export default router
